export const OxPool = "TKnk7zLHS7Bi5YV1LzD8KZDfd5xaTDSbVn";